import React, { FunctionComponent } from "react";
import { Layout, Card } from "@vwfs-bronson/bronson-react";
import { Output } from "../../Text";
import { searchMarketingCardLinks } from "../../common/MarketingCard";

export type MarketingCardsProps = {
  originSystem: string;
  manufacturer: string;
};

const MarketingCards: FunctionComponent<MarketingCardsProps> = (props) => {
  const { originSystem, manufacturer } = props;
  const marketingCardLinks = searchMarketingCardLinks(
    manufacturer,
    originSystem
  );
  const linkMotortInsurance = marketingCardLinks[0]?.linkMotorInsurance;
  const linkLeaseEndProtection = marketingCardLinks[0]?.linkLeaseEndProtection;

  const goToMarketingCardLink = (link: string) => {
    window.open(link, "_blank");
  };

  return (
    <Layout equalHeight center>
      {linkMotortInsurance && (
        <Layout.Item default="1/2" m="1/2" s="1/1">
          <Card
            title={Output.resolve(
              `pages.signatureSuccess.marketingCards.motorInsurance.title`
            )}
            imageSrc={`/assets/images/Image-Kfz-Vers-DE.jpg`}
            small
            subtitle={Output.resolve(
              `pages.signatureSuccess.marketingCards.motorInsurance.subTitle`
            )}
          >
            {Output.resolve(
              `pages.signatureSuccess.marketingCards.motorInsurance.text`
            )}
            <br />
            <footer className="c-card__footer u-mt">
              <button
                className="c-btn  c-btn--link  c-btn--small"
                onClick={() => {
                  goToMarketingCardLink(linkMotortInsurance);
                }}
              >
                <i
                  className="c-btn__icon c-icon  c-icon--[semantic-forward]"
                  aria-hidden="true"
                  role="img"
                ></i>
                <span className="c-btn__text">
                  {Output.resolve(
                    `pages.signatureSuccess.marketingCards.linkText`
                  )}
                </span>
              </button>
            </footer>
          </Card>
        </Layout.Item>
      )}

      {linkLeaseEndProtection && (
        <Layout.Item default="1/2" m="1/2" s="1/1">
          <Card
            title={Output.resolve(
              `pages.signatureSuccess.marketingCards.leaseEndProtection.title`
            )}
            subtitle={Output.resolve(
              `pages.signatureSuccess.marketingCards.leaseEndProtection.subTitle`
            )}
            imageSrc={`/assets/images/Lease-end-protection.jpg`}
            small
          >
            {Output.resolve(
              `pages.signatureSuccess.marketingCards.leaseEndProtection.text`
            )}

            <footer className="c-card__footer u-mt">
              <button
                className="c-btn  c-btn--link  c-btn--small"
                onClick={() => {
                  goToMarketingCardLink(linkLeaseEndProtection);
                }}
              >
                <i
                  className="c-btn__icon c-icon  c-icon--[semantic-forward]"
                  aria-hidden="true"
                  role="img"
                ></i>
                <span className="c-btn__text">
                  {Output.resolve(
                    `pages.signatureSuccess.marketingCards.linkText`
                  )}
                </span>
              </button>
            </footer>
          </Card>
        </Layout.Item>
      )}
    </Layout>
  );
};

export default MarketingCards;
